/* @ngInject */
const myRailwayForm = (
  $$autocomplete,
  $$railway,
  $$area,
  toaster,
  labels
) => {
  return {
    restrict: 'E',
    scope: {
      myRailway: '=',
      enableArea: '=?',
      enableValidator: '=?',
    },
    template: require('./myRailwayForm.html'),

    /* @ngInject */
    controller: (
      $scope
    ) => {
      $scope.fieldsOptions = $$railway.metadata.fields
    },
    link: {
      pre: (scope, element, attrs) => {

      },
      post: async (scope, element, attrs, ctrl) => {
        if (scope.enableArea) {
          try {
            const response = await $$area.request.getBySearch()
            scope.areas = response.areas
            if (!scope.areas.length) {
              toaster.error(labels.railway.log.search.noResult)
            }
          } catch (error) {
            toaster.error(error)
          }
        }

        const leftsPromise = $$autocomplete.request.get('left', 'railway')
        const rightsPromise = $$autocomplete.request.get('right', 'railway')

        try {
          scope.lefts = await leftsPromise
          scope.rights = await rightsPromise
        } catch (error) {
          toaster.error(error)
        }
      },
    },
  }
}

export default myRailwayForm



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/rails/railway/directives/forms/myRailwayForm.js